import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableNewHtmlEditorForPackingSlips = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableNewHtmlEditorForPackingSlips);
};
